import { theme } from '@hhgtech/hhg-components'
import { BabyPoopPage } from 'interfaces/types'

export const colorMap: {
  [color in BabyPoopPage['result'][number]['color']]: {
    [colorType in 'displayColor' | 'backgroundColor' | 'borderColor']: string
  }
} = {
  yellow: {
    displayColor: theme.colors.yellow800,
    backgroundColor: '#F2FCF7',
    borderColor: '#5EC08F',
  },
  red: {
    displayColor: theme.colors.red700,
    backgroundColor: theme.colors.red50,
    borderColor: theme.colors.red500,
  },
  green: {
    displayColor: theme.colors.green600,
    backgroundColor: '#F2FCF7',
    borderColor: '#5EC08F',
  },
}
